import React, { forwardRef, useRef, useState } from "react";
import "../Assets/Styles/SliderSection.css";
import UniversalLife from "./UniversalLife/UniversalLife";
import CriticalIllness from "./CriticalIllness/CriticalIllness";
import TermLife from "./TermLife/TermLife";
import Slider from "react-slick";
import { Container } from "reactstrap";
import { useTranslation } from "../Hooks/useTranslation";
import { useAnimateOnScroll } from "../Hooks/useAnimationScroll";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const OurProducts = forwardRef(({ sectionRef }, ref) => {
  const translations = useTranslation();
  useAnimateOnScroll();

  const [change, setChange] = useState("AM");
  const sliderRef = useRef(null);

  const settings = {
    dots: true,
    arrows: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    pauseOnHover: true,
    adaptiveHeight: true,
    beforeChange: (_, next) => {
      if (next === 0) setChange("AM");
      if (next === 1) setChange("Ward");
      if (next === 2) setChange("Great");
    },
  };

  return (
    <div
      id="our-products"
      ref={ref}
      className="supeior-rating py-16 md:py-16 lg:pt-[100px] lg:pb-[30px] xl:pt-16 xl:pb-36"
    >
      <Container className="relative ">
        <div className="our-products-header reveal-up xl:absolute  mt-0 mb-4 md:mb-6 lg:mb-10 max-w-[420px] lg:max-w-[450px] [@media(min-width:1920px)]:max-w-[655px] w-[100%] z-[9] top-0 lg:pl-0 pl-4 pr-4">
          <p className="text-[28px] leading-[2.8rem] font-semibold mb-5 md:mb-5 tracking-[-0.02em] md:text-[30px] md:leading-[33px] xl:text-[40px] xl:leading-[44px] lg:font-semibold lg:mb-4 md:tracking-[-0.02em] [@media(min-width:1920px)]:text-[45px] [@media(min-width:1920px)]:leading-[50px] [@media(min-width:1920px)]:mb-9 our-products-label">
            {translations.ourProductHeading}
          </p>

          {/* Tabs */}
          <div className="active-section flex gap-2 bg-white rounded-full mb-4 lg:max-w-[320px] xl:max-w-none">
            <button
              onClick={() => {
                setChange("AM");
                sliderRef.current?.slickGoTo(0);
              }}
              className={`flex-1 leading-[16px] text-[14px] md:text-[10.5px] md:leading-[12px] xl:text-[14px] xl:leading-[16px] py-[10px] lg:py-[7px] xl:py-[10px] rounded-full whitespace-nowrap [@media(min-width:1920px)]:!px-3 extra-btn-font
                ${change === "AM" ? "bg-[#103F4B] text-white" : "text-black"}`}
            >
              {translations.universalLifeTab}
            </button>

            <button
              onClick={() => {
                setChange("Ward");
                sliderRef.current?.slickGoTo(1);
              }}
              className={`flex-1 leading-[16px] text-[14px] md:text-[10.5px] md:leading-[12px] xl:text-[14px] xl:leading-[16px] py-[10px] lg:py-[7px] xl:py-[10px] rounded-full whitespace-nowrap [@media(min-width:1920px)]:!px-3 extra-btn-font
                ${change === "Ward" ? "bg-[#103F4B] text-white" : "text-black"}`}
            >
              {translations.termLifeTab}
            </button>

            <button
              onClick={() => {
                setChange("Great");
                sliderRef.current?.slickGoTo(2);
              }}
              className={`flex-1 leading-[16px] text-[14px] md:text-[10.5px] md:leading-[12px] xl:text-[14px] xl:leading-[16px] py-[10px] lg:py-[7px] xl:py-[10px] rounded-full whitespace-nowrap [@media(min-width:1920px)]:!px-3 extra-btn-font
                ${change === "Great" ? "bg-[#103F4B] text-white" : "text-black"}`}
            >
              {translations.criticalIllnessTab}
            </button>
          </div>
        </div>

        {/* Slider */}
        <Slider ref={sliderRef} {...settings}>
          <div>
            <UniversalLife isScrollable />
          </div>
          <div>
            <TermLife isScrollable />
          </div>
          <div>
            <CriticalIllness isScrollable />
          </div>
        </Slider>
      </Container>
    </div>
  );
});

OurProducts.displayName = "OurProducts";
export default OurProducts;
